export const autoScrollToProject = () => {
  
  const init = () => {
    // Only run on project pages
    if (!document.body.classList.contains('page-project')) {
      return;
    }
    
    // Wait for page to be fully loaded and rendered
    setTimeout(() => {
      scrollToExpandedProject();
    }, 800);
  };

  const scrollToExpandedProject = () => {
    // Find the expanded project
    const expandedProject = document.querySelector('.c-project[data-state="expanded"]');
    
    if (!expandedProject) {
      return;
    }

    // Get the project toggle element (the clickable row) - same as toggle-project.js
    const toggleButton = expandedProject.querySelector('.js-project-toggle');
    
    if (!toggleButton) {
      return;
    }

    // Use the exact same functions as toggle-project.js
    const getHeaderOffset = () => {
      const sortHeader = document.querySelector(".c-projects-list-sort");
      if (sortHeader && getComputedStyle(sortHeader).position === 'sticky') {
        const headerStyle = getComputedStyle(sortHeader);
        if (headerStyle.display === 'none' || sortHeader.offsetHeight === 0) {
          return 0;
        }
        
        const headerHeight = sortHeader.offsetHeight;
        return headerHeight;
      }
      return 0;
    };

    const scrollToElementWithOffset = (element, offset) => {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      const finalPosition = Math.max(0, offsetPosition);

      window.scrollTo({
        top: finalPosition,
        behavior: "smooth"
      });
    };

    // Scroll to the toggle button with header offset - exactly like toggle-project.js
    const headerOffset = getHeaderOffset();
    scrollToElementWithOffset(toggleButton, headerOffset);
  };

  init();
};
